import { FC } from 'react'
import Carousel from 'react-material-ui-carousel'
import styled from 'styled-components'
import { CloseCircle } from 'svgIcons'

interface ImageContentViewerProps {
  imageSrcList: string[]
  onDelete?: () => void
  className?: string
}

const ImageContentViewer: FC<ImageContentViewerProps> = ({
  imageSrcList,
  onDelete,
  className,
}) => {
  return (
    <StyledWrapper>
      <Carousel
        timeout={0}
        cycleNavigation={false}
        autoPlay={false}
        navButtonsAlwaysVisible={imageSrcList.length > 1}
        indicators={imageSrcList.length > 1}
        className={className}
      >
        {imageSrcList.map((imageSrc, index) => {
          return (
            <img
              key={`${imageSrc}-${index}`}
              src={imageSrc}
              className="fit-image"
              alt="editor image"
            />
          )
        })}
      </Carousel>
      {!!onDelete && (
        <CloseCircle onClick={onDelete} className="image-preview-close-icon" />
      )}
    </StyledWrapper>
  )
}

export default ImageContentViewer

const StyledWrapper = styled.div`
  position: relative;

  & .fit-image {
    width: 100%;
    height: auto;
    aspect-ratio: 1 / 1;
    object-fit: cover;
    object-position: center center;
  }

  & .image-preview-close-icon {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 28px;
    height: 28px;
    opacity: 0.75;

    & g {
      fill: #333;
      stroke: #333;
    }

    & path {
      fill: white;
    }

    &:hover {
      cursor: pointer;
      opacity: 0.25;
    }
  }
`
